export default __webpack_public_path__ + "static/media/iconNuvemArquivo.0c55b806.svg";